module.exports = __webpack_public_path__ + "static/media/marker-euskooters-green.dd67f38b.svg";